import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { ICellEditorParams } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CdwFilteredTreePickerModule } from '@cdw-ae/common-ui-components-filtered-tree-picker';
import { TreeNode } from '@cdw-ae/common-ui-components-tree';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-tree-picker-cell-editor',
  templateUrl: './tree-picker-cell-editor.component.html',
  styleUrls: ['./tree-picker-cell-editor.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, CdwFilteredTreePickerModule],
  standalone: true,
})
export class TreePickerCellEditorComponent
  implements ICellEditorAngularComp, OnDestroy
{
  dataSource: TreeNode[] = [];
  height = '300px';
  filterPlaceholder = 'Search OUs...';
  filterLabel = 'Filter';
  selectedControl = new FormControl<string | null>(null);
  initialValue: string | null = null;

  private params!: ICellEditorParams;
  private currentValue: string | null = null;
  private destroy$ = new Subject<void>();

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.currentValue = params.value;
    this.initialValue = params.value;

    const cellEditorParams = params.colDef?.cellEditorParams as
      | {
          dataSource?: TreeNode[] | (() => TreeNode[]);
          height?: string;
          filterPlaceholder?: string;
          filterLabel?: string;
        }
      | undefined;

    if (cellEditorParams?.dataSource) {
      const ds = cellEditorParams.dataSource;
      this.dataSource = structuredClone(typeof ds === 'function' ? ds() : ds);
    }

    if (this.currentValue && this.dataSource.length > 0) {
      this.expandAncestorsOf(this.dataSource, this.currentValue);
    }

    if (cellEditorParams?.height) {
      this.height = cellEditorParams.height;
    }
    if (cellEditorParams?.filterPlaceholder) {
      this.filterPlaceholder = cellEditorParams.filterPlaceholder;
    }
    if (cellEditorParams?.filterLabel) {
      this.filterLabel = cellEditorParams.filterLabel;
    }

    this.selectedControl.setValue(params.value ?? null, { emitEvent: false });

    this.selectedControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value != null) {
          this.currentValue = value;
          this.params.api.stopEditing();
        }
      });
  }

  private expandAncestorsOf(nodes: TreeNode[], targetValue: string): boolean {
    for (const node of nodes) {
      if (node.value === targetValue) {
        return true;
      }
      if (node.children?.length && this.expandAncestorsOf(node.children, targetValue)) {
        node.isExpanded = true;
        return true;
      }
    }
    return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getValue(): string | null {
    return this.currentValue;
  }

  isPopup(): boolean {
    return true;
  }

  getPopupPosition(): 'over' | 'under' {
    return 'over';
  }
}
